'use client';
import { atom, useAtom, useSetAtom, WritableAtom } from 'jotai';

export type ChatTriggerPayload = {
  fanId: string;
  fanName: string;
  currentCommunityCreatorId: string;
  fanAvatar: string;
};

type ChatTriggerAction = 'chat' | 'add_to_group' | 'open_chat';

export const chatFanDataAtom = atom<ChatTriggerPayload | null>(null) as WritableAtom<
  ChatTriggerPayload | null,
  [ChatTriggerPayload | null],
  void
>;
export const chatActionAtom = atom<ChatTriggerAction | null>(null) as WritableAtom<
  ChatTriggerAction | null,
  [ChatTriggerAction | null],
  void
>;
export const chatOpenChatAtom = atom<boolean | null>(null) as WritableAtom<
  boolean | null,
  [boolean | null],
  void
>;

export const triggerChatAtom = atom(null, (get, set, payload: ChatTriggerPayload) => {
  set(chatFanDataAtom, payload);
  set(chatActionAtom, 'chat');
});

export const triggerAddToGroupAtom = atom(null, (get, set, payload: ChatTriggerPayload) => {
  set(chatFanDataAtom, payload);
  set(chatActionAtom, 'add_to_group');
});

export const flushChatTriggerAtom = atom(null, (get, set) => {
  set(chatFanDataAtom, null);
  set(chatActionAtom, null);
  set(chatOpenChatAtom, null);
});

export const triggerOpenChatAtom = atom(null, (get, set) => {
  set(chatActionAtom, 'open_chat');
  set(chatOpenChatAtom, true);
});

export function useChatTriggerState() {
  const [chatFanData] = useAtom(chatFanDataAtom);
  const [action] = useAtom(chatActionAtom);
  const [chatOpenChat] = useAtom(chatOpenChatAtom);
  const triggerChat = useSetAtom(triggerChatAtom);
  const triggerAddToGroup = useSetAtom(triggerAddToGroupAtom);
  const flush = useSetAtom(flushChatTriggerAtom);
  const triggerOpenChat = useSetAtom(triggerOpenChatAtom);

  return {
    chatFanData,
    chatOpenChat,
    action,
    onChat: (payload: ChatTriggerPayload) => triggerChat(payload),
    onAddToGroup: (payload: ChatTriggerPayload) => triggerAddToGroup(payload),
    flushChatFanData: flush,
    onOpenChat: () => triggerOpenChat(),
  };
}
